import { render, staticRenderFns } from "./GeneralSummary.vue?vue&type=template&id=bb259d92&scoped=true&"
import script from "./GeneralSummary.vue?vue&type=script&lang=js&"
export * from "./GeneralSummary.vue?vue&type=script&lang=js&"
import style0 from "./GeneralSummary.vue?vue&type=style&index=0&id=bb259d92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb259d92",
  null
  
)

export default component.exports